export const CHAT_ERROR_REASON = {
  // Auth attempt exceeded AUTH_TIMEOUT (typically a slow connection).
  CONNECTION_TIMEOUT: 'CONNECTION_TIMEOUT',
  // WebSocket/transport failed to connect.
  CONNECTION_FAILED: 'CONNECTION_FAILED',
  // Server reached but login was rejected (bad/expired token, no access).
  AUTH_REJECTED: 'AUTH_REJECTED',
};

export function notifyChatFatalError(reason) {
  const message = JSON.stringify({ type: 'fatal_error', reason: reason });
  try {
    if (window.FlutterBridge && typeof window.FlutterBridge.postMessage === 'function') {
      window.FlutterBridge.postMessage(message);
    }
  } catch (err) {
    console.error('Failed to notify chat fatal error', reason, err);
  }
}
